(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-popular-products"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.quick-view-btn').forEach(btn => {
  btn.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    const handle = this.dataset.productHandle;
    const modal = document.getElementById('quick-view-modal');
    const overlay = document.getElementById('quick-view-overlay');
    const modalBody = modal.querySelector('.quick-view-body');
    modalBody.innerHTML = '<div class="quick-view-loader"><div class="loader-spinner"></div></div>';
    overlay.classList.add('active');
    modal.classList.add('active');
    fetch(`/products/${handle}?view=quick`)
      .then(res => res.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const productWrapper = tempDiv.querySelector('.Product__Wrapper');
        if (productWrapper) {
          modalBody.innerHTML = productWrapper.outerHTML;
        } else {
          const productContainer = tempDiv.querySelector('.product-container, .product-single, .product-details, .product, [class*="product"]');
          modalBody.innerHTML = productContainer ? productContainer.outerHTML : html;
        }
        modalBody.querySelectorAll('img, a, button, .product-title, [class*="title"]').forEach(el => {
          el.style.pointerEvents = 'auto';
          el.style.cursor = 'pointer';
        });
        modalBody.querySelectorAll('a').forEach(link => {
          if (!link.getAttribute('href') || link.getAttribute('href') === '#') {
            link.style.pointerEvents = 'none';
          }
        });
        reinitializeProductForm(modalBody);
      })
      .catch(err => {
        console.error('Quick View fetch error:', err);
        modalBody.innerHTML = '<div class="quick-view-loader"><p>Error loading product. Please try again.</p></div>';
      });
  });
});
function reinitializeProductForm(container) {
  var productJsonEl = container.querySelector('[data-product-json]');
  if (!productJsonEl) return;
  var productData = JSON.parse(productJsonEl.textContent).product;
  var form = container.querySelector("form.ProductForm");
  if (!form) return;
  var hiddenInput = form.querySelector("select[name='id'], input[name='id']");
  if (!hiddenInput) return;
  function updateVariantId() {
    var selectedOptions = [];
    container.querySelectorAll(".ProductForm__Option input:checked, .ProductForm__Option button.is-selected").forEach(function(el){
      selectedOptions[parseInt(el.dataset.optionPosition) - 1] = el.value || el.dataset.value;
    });
    var matchedVariant = productData.variants.find(function(variant) {
      return variant.options.every(function(option, index) {
        return option === selectedOptions[index];
      });
    });
    if (matchedVariant) {
      hiddenInput.value = matchedVariant.id;
      var priceEl = container.querySelector('.ProductMeta__Price');
      if (priceEl && matchedVariant.price) {
        priceEl.textContent = 'Rs. ' + (matchedVariant.price / 100).toLocaleString('en-IN');
      }
    }
  }
  container.querySelectorAll(".ProductForm__Option input[type='radio']").forEach(function(radio){
    radio.addEventListener("change", updateVariantId);
  });
  container.querySelectorAll(".ProductForm__Option button[data-action='select-value']").forEach(function(btn){
    btn.addEventListener("click", function(){
      var popover = btn.closest('.Popover');
      popover.querySelectorAll("button").forEach(function(b){ b.classList.remove("is-selected"); });
      btn.classList.add("is-selected");
      var mainBtn = popover.previousElementSibling;
      if (mainBtn) {
        var selectedValue = mainBtn.querySelector('.ProductForm__SelectedValue');
        if (selectedValue) selectedValue.textContent = btn.dataset.value;
      }
      popover.setAttribute('aria-hidden', 'true');
      updateVariantId();
    });
  });
  container.querySelectorAll("button[aria-controls]").forEach(function(btn){
    btn.addEventListener("click", function(e){
      e.preventDefault();
      var popoverId = btn.getAttribute('aria-controls');
      var popover = document.getElementById(popoverId);
      if (popover) {
        var isHidden = popover.getAttribute('aria-hidden') === 'true';
        popover.setAttribute('aria-hidden', !isHidden);
        btn.setAttribute('aria-expanded', isHidden);
      }
    });
  });
  container.querySelectorAll('[data-action="close-popover"]').forEach(function(btn){
    btn.addEventListener("click", function(){
      var popover = btn.closest('.Popover');
      if (popover) popover.setAttribute('aria-hidden', 'true');
    });
  });
  container.querySelectorAll('[data-action="decrease-quantity"]').forEach(function(btn){
    btn.addEventListener("click", function(){
      var input = container.querySelector('.QuantitySelector__CurrentQuantity');
      if (input) {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      }
    });
  });
  container.querySelectorAll('[data-action="increase-quantity"]').forEach(function(btn){
    btn.addEventListener("click", function(){
      var input = container.querySelector('.QuantitySelector__CurrentQuantity');
      if (input) {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      }
    });
  });
  updateVariantId();
}
function closeQuickView() {
  const modal = document.getElementById('quick-view-modal');
  const overlay = document.getElementById('quick-view-overlay');
  modal.classList.remove('active');
  overlay.classList.remove('active');
}
document.querySelector('.quick-view-close').addEventListener('click', closeQuickView);
document.getElementById('quick-view-overlay').addEventListener('click', closeQuickView);
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeQuickView();
});

  } catch(e) { console.error(e); }
})();
})();
